<template>
  <div id="create-profile-candidate">
    <nav-bar-top icons-are-hidden />
    <template v-if="activeStep === 0">
      <welcome-candidate
        @nextStep="nextStep"
        @checkForm="validate"
      />
    </template>
    <div
      v-else
      class="container has-nav-top-margin"
    >
      <section
        id="progress"
        class="section"
      >
        <h4 class="title is-4">
          Create a Profile
        </h4>
        <p class="subtitle">
          Show companies what you're made of.
        </p>
        <percent-bar :amount-completed="progressValue" />
        <!--<p class="percent-progress">{{ progressValue * 10 + '%' }}</p>-->
      </section>

      <!-- GLOBAL - LOADING SPINNER  -->
      <section
        v-if="isLoading"
        id="location"
        class="section step-section"
      >
        <div class="card card-content">
          <loading-spinner />
        </div>
      </section>

      <!-- STEP 1 - LOCATION -->
      <section
        v-if="activeStep === 1 && !isLoading"
        id="location"
        class="section step-section"
      >
        <div class="card card-content">
          <locations-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 2 - INDUSTRIES-->
      <section
        v-if="activeStep === 2 && !isLoading"
        id="industries"
        class="section step-section"
      >
        <div class="card card-content">
          <industries-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 3 - SKILLS -->
      <section
        v-if="activeStep === 3 && !isLoading"
        id="skills"
        class="section step-section"
      >
        <div class="card card-content">
          <skills-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 4 - EDUCATION -->
      <section
        v-if="activeStep === 4 && !isLoading"
        id="education"
        class="section step-section"
      >
        <div class="card card-content">
          <education-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 5 - COMPANIES -->
      <section
        v-if="activeStep === 5 && !isLoading"
        id="companies"
        class="section step-section"
      >
        <div class="card card-content">
          <companies-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 6 - ACCOMPLISHMENTS -->
      <section
        v-if="activeStep === 6 && !isLoading"
        id="companies"
        class="section step-section"
      >
        <div class="card card-content">
          <accomplishments-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 7 - ABOUT -->
      <section
        v-if="activeStep === 7 && !isLoading"
        id="skills"
        class="section step-section"
      >
        <div class="card card-content">
          <about-candidate @checkForm="validate" />
        </div>
      </section>

      <!-- STEP 8 - CONGRATS -->
      <section
        v-if="activeStep === 8 && !isLoading"
        id="congrats"
        class="section step-section"
      >
        <div class="card card-content">
          <congrats-candidate />
        </div>
      </section>

      <!-- BACK/NEXT BAR -->
      <section
        v-if="activeStep !== 8 && !isLoading"
        id="step-navigation"
        class="section no-pad-top"
      >
        <div class="columns is-mobile is-marginless">
          <div class="column has-text-left">
            <button
              class="button is-rounded is-primary has-text-weight-bold is-outlined"
              @click="previousStep"
            >
              Back
            </button>
          </div>
          <div
            v-if="activeStep !== 7 "
            class="column has-text-right"
          >
            <button
              class="button is-rounded is-primary has-text-weight-bold"
              @click="nextStep"
            >
              Next
            </button>
          </div>
          <div
            v-else-if="activeStep === 7"
            class="column has-text-right"
          >
            <button
              class="button is-rounded is-primary has-text-weight-bold"
              @click="nextStep"
            >
              Finish!
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import LocationsCandidate from '@/components/CandidateProfile/LocationsCandidate';
import SkillsCandidate from '@/components/CandidateProfile/SkillsCandidate';
import AccomplishmentsCandidate from '@/components/CandidateProfile/AccomplishmentsCandidate';
import EducationCandidate from '@/components/CandidateProfile/EducationCandidate';
import CompaniesCandidate from '@/components/CandidateProfile/CompaniesCandidate';
import CongratsCandidate from '@/components/CandidateProfile/CongratsCandidate';
import WelcomeCandidate from '@/components/CandidateProfile/WelcomeCandidate';
import AboutCandidate from '@/components/CandidateProfile/AboutCandidate';
import IndustriesCandidate from '@/components/CandidateProfile/IndustriesCandidate';
import PercentBar from '@/components/Utilities/PercentBar';
import LoadingSpinner from '@/components/Utilities/LoadingSpinner';

export default {
  name: 'CreateProfileCandidate',
  components: {
    NavBarTop,
    LocationsCandidate,
    SkillsCandidate,
    EducationCandidate,
    CompaniesCandidate,
    CongratsCandidate,
    WelcomeCandidate,
    AboutCandidate,
    IndustriesCandidate,
    PercentBar,
    AccomplishmentsCandidate,
    'loading-spinner': LoadingSpinner
  },
  data () {
    return {
      isLoading: false,
      account: null,
      temporaryStepIndex: 0,
      isFormValid: true
    };
  },
  computed: {
    profile () {
      return this.$store.state.user.profile;
    },
    progressValue () {
      switch (this.activeStep) {
        case 1:
          return 20 / 10;
        case 2:
          return 30 / 10;
        case 3:
          return 40 / 10;
        case 4:
          return 60 / 10;
        case 5:
          return 70 / 10;
        case 6:
          return 90 / 10;
        case 7:
          return 100 / 10;
        default:
          return 10;
      }
    },
    activeStep () {
      return parseInt(this.$store.getters.candidateProfileCreationCurrentStep);
    },
    isStepCompleted () {
      // VALIDATION FOR
      // 1. LOCATION
      if (this.activeStep === 1) {
        if (
          !this.profile.location.undisclosed
          && this.profile.location.current === ''
        ) {
          return false;
        }
      // 2. INDUSTRIES
      } else if (this.activeStep === 2) {
        let l = this.profile.industries.current.length;
        if (l === 0) {
          return false;
        } else if (
          l > 0
          && (!this.profile.industries.current[l - 1].industry
            || !this.profile.industries.current[l - 1].years_experience)
        ) {
          return false;
        }
      // 3. SKILLS
      } else if (this.activeStep === 3) {
        let l = this.profile.skills.length;
        if (l === 0) {
          return false;
        }
      // 4. EDUCATION
      } else if (this.activeStep === 4) {
        // No validation needed here for now.
        return true;
      // 5. COMPANIES
      } else if (this.activeStep === 5) {
        let l = this.profile.companies.length;
        if (l === 0) {
          return false;
        } else if (
          l > 0
          && (!this.profile.companies[l - 1].annual_revenue
            || !this.profile.companies[l - 1].corporate_structure
            || !this.profile.companies[l - 1].number_of_employees
            || !this.profile.companies[l - 1].role)
        ) {
          return false;
        }
      // 6. ACCOMPLISHMENTS
      } else if (this.activeStep === 6) {
        let l = this.profile.accomplishments.length;
        let emptyAccomplishments = this.profile.accomplishments.filter(
          str => str.length === 0
        );
        if (l === 0 || emptyAccomplishments.length > 0) {
          return false;
        }
      } else if (this.activeStep === 7) {
        if (this.profile.bio.length === 0) {
          return false;
        }
      }
      return true;
    }
  },
  created () {
    this.account = this.$store.state.user.account;
    this.temporaryStepIndex = this.$store.getters.candidateProfileCreationCurrentStep;
  },
  methods: {
    nextStep () {
      this.updateCandidateProfile('next');
    },
    previousStep () {
      this.updateCandidateProfile('previous');
    },
    updateCandidateProfile (moveStep) {
      if (moveStep === 'next' && (!this.isStepCompleted || !this.isFormValid)) {
        this.$toasted.show('Please complete this step to continue');
        return;
      }
      this.isLoading = true;

      if (moveStep === 'next') {
        this.temporaryStepIndex = this.temporaryStepIndex + 1;
      } else if (moveStep === 'previous') {
        this.temporaryStepIndex = this.temporaryStepIndex - 1;
      }
      this.$store.dispatch('updateProfileCreationStep', this.temporaryStepIndex)
        .then(() => this.$store.dispatch('editCandidateProfile', this.$store.getters.getUserProfile))
        .then(response => {
          if (response.data.status !== 'saved') {
            this.isLoading = false;
            this.$toasted.show('Oops, something went wrong!');
          } else {
            this.$store.commit(
              'UPDATE_CANDIDATE_PROFILE',
              response.data.data.profile
            );
            this.isLoading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.$toasted.show('Oops, something went wrong!');
        });
    },
    validate ($event) {
      this.isFormValid = $event;
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-container {
  border-width: 2px 3px 2px 4px;
  border-radius: 20% 4% 30% 5%/4% 25% 6% 20%;
  height: 30px;
  width: 100%;
}

.percent-progress {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.progress-bar {
  border-width: 2px 3px 2px 4px;
  border-radius: 20% 4% 30% 5%/4% 25% 6% 20%;
  height: 31px;
  width: 100%;
  margin-left: 2px;
  background-color: rgba(0, 0, 0, 0.4);
}

@media screen and (min-width: 1088px) {
  .section.is-medium {
    padding: 3rem 1.5rem;
  }
}

.step-section {
  padding-top: 1rem;
}

.experience-input {
  width: 100px;
}

@media screen and (max-width: 767px) {
  #step-navigation {
    position: fixed;
    background-color: white;
    left: 0;
    bottom: 0px;
    width: 100vw;
    min-height: 60px;
    padding-top: 0;
    z-index: 10000;
    margin-top: 0;
    padding: 0 1rem;
    box-shadow: 0 -2px 20px 0 rgba(133, 191, 244, 0.2);
  }
  .step-section {
    margin-bottom: 60px;
  }
}

.is-white {
  background-color: white;
  border: none;
  color: #363636;
}

.button.is-small {
  vertical-align: bottom;
}

#progress {
  padding-top: 1.25rem;
  padding-bottom: 1rem;
}
</style>
